/**
 * Pathfinder key for allocation endpoint.
 */
export const ALLOCATE_ENDPOINT = 'experiment_allocate_api';

/**
 * Pathfinder key for dangerous allocation endpoint.
 */
export const DANGEROUSLY_ALLOCATE_ENDPOINT = 'experiment_dangerously_allocate_api';
